import {srcsetData} from 'src/utils/base';
import {
  deleteQueryParam,
  getQueryParam,
  searchParams,
  setQueryParam
} from '../utils/url';

class StyleHero {
  constructor() {
    this.root = '.pc-Style-hero';
    this.toggleColors = this.toggleColors.bind(this);
    this.updateNdxParams = this.updateNdxParams.bind(this);
    this.addQueryToUrl = this.addQueryToUrl.bind(this);
    this.removeQueryFromUrl = this.removeQueryFromUrl.bind(this);
    this.fireGetQuoteTag = this.fireGetQuoteTag.bind(this);
    this.attachCta = this.attachCta.bind(this);
    this.detachCta = this.detachCta.bind(this);
    this.updatePricingLine = this.updatePricingLine.bind(this);
    this.handleImageSurveyClick = this.handleImageSurveyClick.bind(this);
    this.colorToggleSelector = '#pc-Style-colors-qtyToggle';
    this.quickViewToggleSelector = '#pc-QuickView-qtyToggle';
    this.ctaSelector = '.pc-Style-hero-cta';
    this.hoverableColorNameSelector =
      '.pc-Style-hero-colors .pc-Style-selectedColor-name';
    this.quickViewColorNameSelector = '.pc-QuickView-selectedColor-name';
    this.imageSelector = '.pc-Style-selectedColor-image';
    this.imageDesignSelector = '.pc-Style-hero-image-designicon';
    this.nonInteractiveSwatchSelector = '.pc-Swatch-noninteractive';
    this.pricingLineSelector = '.pc-Style-hero-pricing-price-line.price-quote';
    this.colorsLineSelector = '.pc-Style-hero-pricing-price-line.design-colors';
    this.sampleDetailsSelector =
      '.pc-Style-hero-pricing-price-line.sample-details';
    this.sampleFormSelector = '.pc-Style-reqSample';
    this.pricingTooltipSelector = '.pc-Style-hero-pricing-tooltip';
    this.pricingTooltipTriggerSelector = '#pc-Tooltip-getQuoteLink';
    this.pricingQuickQuoteSelector = '.pc-Style-actions-qq';
    this.swatchSelector = '.pc-Swatch';
    this.swatchTrimSelector = '.pc-Swatch-trim';
    this.plaCtas = {
      pla_pre_printed_sample: 'Or order a printed sample for',
      pla_printed_sample: 'Or order a printed sample for',
      pla_blank_sample: 'Or order 1 blank sample for'
    };
    this.setupLabLink();
    $(document).on('change.style', this.colorToggleSelector, this.toggleColors);
    $(document).on(
      'change.style',
      this.colorToggleSelector,
      this.updateNdxParams
    );
    $(document).on(
      'change.style',
      this.quickViewToggleSelector,
      this.toggleColors
    );
    $(document).on('updated.style.quoting', (e, data) => {
      this.updatePricingLine(data);
      this.updatePrice(data);
      return this.updateTooltipFactors(data);
    });
    $(document).on('swatchhover.style.colorinteraction', (e, data) => {
      if (navigator.maxTouchPoints > 0) {
        return;
      }
      this.updateHoverSwatch(data);
      this.updateSizing(data);
      if (!ProductCatalog.QuickView.isQuickView()) {
        return this.preloadImage(data);
      }
    });
    $(document).on('swatchselect.style.colorinteraction', (e, data) => {
      if (!ProductCatalog.QuickView.isQuickView()) {
        this.updateImage(data);
        this.updateDesignIcon(data);
        this.updateCta(data);
        this.updateOgImage(data);
        this.updateSizing(data);
        this.updateSamplePrice(data);
      }
      this.updateTooltipColor(data);
      return this.updateQuickQuoteLink(data);
    });
    $(document).on(
      'click.style',
      this.pricingTooltipTriggerSelector,
      this.fireGetQuoteTag
    );
    $('.pc-Style-hero-imageSurvey-link').on(
      'click',
      this.handleImageSurveyClick
    );

    enquire.register(StyleBitz.Layouts.sm, this.detachCta);
    enquire.register(StyleBitz.Layouts.md, this.attachCta);
    enquire.register(StyleBitz.Layouts.lg, this.attachCta);
    enquire.register(StyleBitz.Layouts.xl, this.attachCta);
  }

  setupLabLink() {
    const labLink = $('a.is-pcLabLink');
    labLink.attr('href', labLink.data('href'));
  }

  // Private: Event Handlers

  // This toggle is generally used to flip between singles and bulk color swatch sets.
  // But! You can set a value on the toggle checkbox and pivot on any number you'd like.
  toggleColors(e) {
    const $toggle = $(e.target);
    const pivot_qty = parseFloat($toggle.val(), 10) || 0;
    const $swatches = $(this.swatchSelector);
    const switchSelectedSwatch =
      $('.pc-Swatch.is-selected').data('min-qty') >= pivot_qty;
    let swatchSwitched = false;
    if ($toggle.prop('checked')) {
      this.addQueryToUrl({quote_qty: 'min'});
    } else {
      this.removeQueryFromUrl('quote_qty');
    }
    const eventTagLabel = $toggle.prop('checked') ? 'on' : 'off';
    if (ProductCatalog.QuickView.isQuickView()) {
      ProductCatalog.QuickView.toggleColorCount();
    }
    for (let swatch of Array.from($swatches.toArray())) {
      const $swatch = $(swatch);
      if ($toggle.prop('checked')) {
        if (parseFloat($swatch.data('min-qty'), 10) >= pivot_qty) {
          if ($swatch.is(':visible')) {
            $swatch.prop('hidden', true);
          }
        } else if (!swatchSwitched && switchSelectedSwatch) {
          $swatch.click();
          swatchSwitched = true;
        }
      } else {
        if ($swatch.is(':hidden')) {
          $swatch.prop('hidden', false);
        }
      }
    }
    return CustomInk.Metrics.fireEvent(
      'product quantity',
      'order fewer than six',
      eventTagLabel
    );
  }

  updateNdxParams(e) {
    const isChecked = e.currentTarget.checked;
    const links = $('a.is-pcLabLink');
    return links.each((index, link) => {
      const linkSelector = $(link);
      const url = setQueryParam(
        'prefer_singles',
        isChecked,
        linkSelector.attr('href')
      );
      return linkSelector.attr('href', url);
    });
  }

  addQueryToUrl(params = {}) {
    let url = window.location.href;
    for (let key of Array.from(Object.keys(params))) {
      url = setQueryParam(key, params[key], url);
    }
    const title = $('title').text();
    return window.history.replaceState({}, title, url);
  }

  removeQueryFromUrl(param) {
    const url = deleteQueryParam(param);
    const title = $('title').text();
    return window.history.replaceState({}, title, url);
  }

  fireGetQuoteTag(e) {
    return CustomInk.Metrics.fireEvent('get quote', 'details link', null);
  }

  // Private: Enquire Handlers

  attachCta() {
    return requestAnimationFrame(() =>
      $(this.ctaSelector).removeClass('is-fixed')
    );
  }

  detachCta() {
    return requestAnimationFrame(() =>
      $(this.ctaSelector).addClass('is-fixed')
    );
  }

  isColorWithDesign() {
    const sel = '.pc-Style-hero-image[data-requested-color-with-design=true]';
    return $(sel).length > 0;
  }

  // Private: Helpers

  isQuoteTypePrePrintedSample() {
    const queryParams = searchParams();
    return (
      queryParams.get('pre_printed_sample') === 'true' &&
      queryParams.get('samples') === 'true'
    );
  }

  isPrePrintedSampleEligible() {
    const queryParams = searchParams();
    return (
      (this.isQuoteTypePrePrintedSample() &&
        queryParams.get('pre_printed_color') === queryParams.get('PK'))
    );
  }

  isPlaPrintedSampleEligible(color) {
    const queryParams = searchParams();
    return (
      (queryParams.get('printed_sample') === 'true' &&
        queryParams.get('samples') === 'true' &&
        color.singlesEnabled)
    );
  }

  updatePricingLine(data) {
    const colorCountsFront = parseInt(data.original.color_counts_front, 10);
    const colorCountsBack = parseInt(data.original.color_counts_back, 10);
    return $(this.colorsLineSelector).text(
      colorCountsFront && colorCountsBack
        ? `Quote includes free shipping with a ${colorCountsFront}-color front, ${colorCountsBack}-color back custom design.`
        : colorCountsFront
        ? `Quote includes free shipping with a ${colorCountsFront}-color front custom design.`
        : colorCountsBack
        ? `Quote includes free shipping with a ${colorCountsBack}-color back custom design.`
        : 'Quote includes free shipping with a custom design.'
    );
  }

  hideSampleDetails() {
    $(this.sampleDetailsSelector).hide();
    return this.hideSampleForm();
  }

  showSampleDetails() {
    return $(this.sampleDetailsSelector).show();
  }

  hideSampleForm() {
    return $(this.sampleFormSelector).hide();
  }

  showSampleForm() {
    return $(this.sampleFormSelector).show();
  }

  updatePrice(data) {
    const qty = parseInt(data.original.quantity, 10);
    const priceFloat = parseFloat(data.original.each);
    const price = `${priceFloat}`;
    const total = `$${priceFloat * qty}`;
    $(this.pricingLineSelector)
      .find('span.unit-price')
      .text(price)
      .end()
      .find('span.quote-qty')
      .text(qty)
      .end()
      .find('.total')
      .text(total);
  }

  updateHoverSwatch(data) {
    const selector = ProductCatalog.QuickView.isQuickView()
      ? this.quickViewColorNameSelector
      : this.hoverableColorNameSelector;
    const $swatch = $(selector).siblings(this.nonInteractiveSwatchSelector);
    $(selector).text(data.name);
    $swatch
      .css({
        'background-color': data.color,
        'border-color': 'rgba(0, 0, 0, 0.2)'
      })
      .find(this.swatchTrimSelector)
      .prop('hidden', true);
    if (data.trimColor) {
      return $swatch
        .find(this.swatchTrimSelector)
        .css('background-color', data.trimColor)
        .prop('hidden', false);
    }
  }

  preloadImage(data) {
    return ProductCatalog.ImagePreloader.preload(
      this.imageSrcFromSwatchData(data),
      this.imageSrcSetFromSwatchData(data)
    );
  }

  updateImage(data) {
    const newImageUrl = this.imageSrcFromSwatchData(data);
    const newSrcSet = this.imageSrcSetFromSwatchData(data);
    $(this.imageSelector).attr('srcset', newSrcSet);
    return $(this.imageSelector).attr('src', newImageUrl);
  }

  hasDesignSlide() {
    return $(this.imageDesignSelector).attr('data-original-src') !== undefined;
  }

  updateDesignIcon(data) {
    if (this.hasDesignSlide()) {
      const newDesignUrl = this.designSrcFromSwatchData(data);
      return $(this.imageDesignSelector).attr('src', newDesignUrl);
    }
  }

  updateOgImage(data) {
    const ogImageURL = $('meta[property="og:image"]').attr('content');
    if (!ogImageURL) {
      return;
    }
    const newImageUrl = `https://mms-images.out.customink.com/mms/images/catalog/colors/${data.colorid}/views/alt/front_medium_extended.png`;
    $('meta[property="og:image"]').attr('content', newImageUrl);
  }

  updateSizing(data) {
    $('.pc-Style-hero-sizeRange').html(data.sizeRange);
    $('.pc-Style-hero-colors-sizeList.oos').html(data.colorSizeListHtml);
    $('.pc-Style-hero-colors-stockWarning').html(data.colorSizesStockWarning);
    if ($('.pc-Style-hero-blanksSection, .pc-Style-samplesForm').length) {
      const sizeSelectOptions = data.sizeDisplayList.split(', ');
      const sizeSelectDropDown = $('#sizes');
      sizeSelectDropDown.empty();
      return sizeSelectOptions.forEach(function (value) {
        const option = new Option(value, value);
        sizeSelectDropDown.append(option);
      });
    }
  }

  updateSamplePrice(data) {
    let [plaType, quantity, frontCc] = Array.from([null, 1, 0]);
    if (this.isPrePrintedSampleEligible()) {
      [plaType, quantity, frontCc] = Array.from([
        'pla_pre_printed_sample',
        10000,
        1
      ]);
    } else if (this.isPlaPrintedSampleEligible(data)) {
      plaType = 'pla_printed_sample';
    } else if (getQueryParam('samples') === 'true') {
      plaType = 'pla_blank_sample';
    } else {
      this.hideSampleDetails();
      return;
    }
    return this.getNewSamplePrice(data, plaType, quantity, frontCc);
  }

  updateHiddenFormFields(plaType) {
    let [orderType, cid] = Array.from([null, null]);
    if (plaType === 'pla_printed_sample') {
      [orderType, cid] = Array.from([
        'pla_printed_sample',
        getQueryParam('cid')
      ]);
    }
    $('#order_type').val(orderType);
    return $('#design_cid').val(cid);
  }

  updateSampleLink(plaType, productId, price) {
    const formattedPrice = Number.parseFloat(price).toFixed(2);
    const cta = this.plaCtas[plaType];
    if (plaType === 'pla_pre_printed_sample') {
      let href = `https://customink-samples.myshopify.com/collections/all-samples-collection/products/${productId}`;
      $('.pc-plaSampleLink').removeClass('pc-Style-requestSamplePla');
      $('.pc-plaSampleLink').attr('href', href);
      this.hideSampleForm();
    } else {
      $('.pc-plaSampleLink').addClass('pc-Style-requestSamplePla');
      $('.pc-plaSampleLink').removeAttr('href');
      this.updateHiddenFormFields(plaType);
      this.showSampleForm();
    }
    $('.pc-Style-hero-pricing-price-line')
      .find('span.sample-cta')
      .text(`${cta}`);
    return $('.pc-Style-hero-pricing-price-line')
      .find('span.sample-price')
      .text(`$${formattedPrice}`);
  }

  getNewSamplePrice(data, plaType, quantity, frontCc) {
    const path = this.newPlaQuotePath();
    const productId = data.id;
    const params = {
      product_id: productId,
      order_type: plaType,
      quantity,
      front_cc: frontCc
    };
    return $.ajax(path, {
      type: 'GET',
      dataType: 'json',
      data: params,
      error: (jqXHR, textStatus, errorThrown) => {
        return this.hideSampleDetails();
      },
      success: (data, textStatus, jqXHR) => {
        if (data.valid) {
          this.updateSampleLink(plaType, productId, data.price);
          return this.showSampleDetails();
        } else {
          return this.hideSampleDetails();
        }
      }
    });
  }

  newPlaQuotePath() {
    const meta = $('meta[property=newplaquotespath]');
    if (!(meta.length > 0)) {
      return undefined;
    }
    return meta.attr('content');
  }

  imageUrl() {
    return $(this.imageSelector).attr('data-original-src');
  }

  imageDesignUrl() {
    return $(this.imageDesignSelector).attr('data-original-src');
  }

  imageSrcSet() {
    return $(this.imageSelector).attr('data-original-srcset');
  }

  designSrcSet() {
    return $(this.imageDesignSelector).attr('data-original-srcset');
  }

  updateImageDesign(url, data) {
    if (data.cid != null) {
      url = setQueryParam('design', data.cid, url);
    }
    if (this.isColorWithDesign()) {
      return url;
    }
    const cid = getQueryParam('cid');
    if (
      this.isPrePrintedSampleEligible() ||
      this.isPlaPrintedSampleEligible(data) ||
      ProductCatalog.KeepShopping.isEligible() ||
      ProductCatalog.MultiItem.isEligible()
    ) {
      url = setQueryParam('design', cid, url);
    }
    return url;
  }

  imageSrcFromSwatchData(data) {
    let src = this.imageUrl().replace(/\/\d+\//, `/${data.colorid}/`);
    src = this.updateImageDesign(src, data);
    return src;
  }
  designSrcFromSwatchData(data) {
    let src = this.imageDesignUrl().replace(/\/\d+\//, `/${data.colorid}/`);
    return src;
  }

  imageSrcSetFromSwatchData(data) {
    let srcsets = srcsetData(this.imageSrcSet());
    srcsets = (() => {
      const result = [];
      for (let srcset of Array.from(srcsets)) {
        srcset[0] = srcset[0].replace(/\/\d+\//g, `/${data.colorid}/`);
        srcset[0] = this.updateImageDesign(srcset[0], data);
        result.push(srcset.join(' '));
      }
      return result;
    })();
    return srcsets.join(', ');
  }

  designSrcSetFromSwatchData(data) {
    let srcsets = srcsetData(this.designSrcSet());
    srcsets = (() => {
      const result = [];
      for (let srcset of Array.from(srcsets)) {
        srcset[0] = srcset[0].replace(/\/\d+\//g, `/${data.colorid}/`);
        srcset[0] = this.updateImageDesign(srcset[0], data);
        result.push(srcset.join(' '));
      }
      return result;
    })();
    return srcsets.join(', ');
  }

  updateCta(data) {
    const links = $('a.is-pcLabLink, a.is-buyNowLink');
    let url = setQueryParam('PK', data.colorid, links.attr('href'));
    if (data.cid != null) {
      url = setQueryParam('cid', data.cid, url);
    }
    return links.attr('href', url);
  }

  updateQuickQuoteLink(data) {
    const links = $(this.pricingQuickQuoteSelector);
    if (links.length === 0) {
      return;
    }
    const url = setQueryParam('product_id', data.colorid, links.attr('href'));
    return links.attr('href', url);
  }

  updateTooltipColor(data) {
    return $(this.pricingTooltipSelector)
      .find('.pc-Style-hero-pricing-tooltip-color')
      .text(data.name);
  }

  updateTooltipFactors(data) {
    return $(this.pricingTooltipSelector)
      .find('.pc-Style-hero-pricing-tooltip-quantity')
      .text(data.original.quantity)
      .end()
      .find('.pc-Style-hero-pricing-tooltip-colorNumber')
      .text(data.original.color_counts_front);
  }

  // These functions handle click events for Product Images Medallia survey. Click events will show form
  // on click or when the form has fully loaded from the KAMPYLE API
  handleImageSurveyClick() {
    const surveyFormId = 10959;
    const showMedalliaSurvey = () => KAMPYLE_ONSITE_SDK.showForm(surveyFormId);
    if (window.KAMPYLE_ONSITE_SDK) {
      showMedalliaSurvey();
    } else {
      window.addEventListener('neb_OnsiteLoaded', showMedalliaSurvey);
    }
  }
}

jQuery(() => (ProductCatalog.StyleHero = new StyleHero()));
